import { toast } from 'react-toastify';

function wargingError(message: string) {
  toast.error(message);
}
function wargingSuccess(message: string) {
  toast.success(message);
}
function wargingAlert(message: string) {
  toast.warning(message, {
    style: {
      backgroundColor: 'orange',
    },
  });
}
function wargingInfo(message: string) {
  toast.info(message);
}
export default {
  wargingError,
  wargingSuccess,
  wargingAlert,
  wargingInfo,
};
